import type { MultiPolygonG2D } from '@ev-tech/search-modules-api';

import { MapMode } from '../hooks/stores/search/slices/mapInteractionSlice';
import { isMultiPolygonBoundingBox } from '../components/MapViewer/components/DrawPolygons/multiPolygonGeometryUtils';

/** Infers map interaction mode from multipolygon geometry when `mapMode` is not in the URL. */
export const inferMapModeFromMultiPolygon = (multiPolygon?: MultiPolygonG2D): MapMode | undefined => {
  if (!multiPolygon?.coordinates?.length) {
    return undefined;
  }

  return isMultiPolygonBoundingBox(multiPolygon) ? MapMode.BOUNDING_BOX_MODE : MapMode.MULTI_POLYGON_MODE;
};

export const resolveMapModeForSearchState = (mapMode: MapMode | undefined, multiPolygon?: MultiPolygonG2D): MapMode => {
  return mapMode ?? inferMapModeFromMultiPolygon(multiPolygon) ?? MapMode.PLACE_MODE;
};
